import { ReadOnlyField } from '@/components/atoms/ReadOnlyField/ReadOnlyField';
import { InfobipRcsIntegration, InfobipSmsIntegration } from '@/shared/types/integration';

import CardBase from '../Components/CardBase';

export interface OverviewField {
  label: string;
  value?: string;
}

interface Props {
  integration: InfobipSmsIntegration | InfobipRcsIntegration;
  title: string;
  fields: OverviewField[];
}

export const ConfigurationOverviewCard = ({ integration, title, fields }: Props) => (
  <CardBase
    title={title}
    titleVariant="secondary"
    status={integration.status}
    active={integration.active}
  >
    {fields.map(({ label, value }) => (
      <ReadOnlyField key={label} label={label} value={value} labelClassName="text-foreground" />
    ))}
  </CardBase>
);
